import angular from 'angular';
import uiRouter from 'angular-ui-router';
import timeSelectFormElementComponent from './timeSelectFormElement.component';

let timeSelectFormElementModule = angular.module('timeSelectFormElement', [
  uiRouter
])

.component('timeSelectFormElement', timeSelectFormElementComponent)

.name;

export default timeSelectFormElementModule;
